<template>
<div>
  <i class="ml-2 fa fa-print fa-lg"></i><span class="h6 ml-2">{{ $t('views.excmdevice.list.title') }}</span>
  <hr class="mb-1 mt-1">
  <table class="table table-sm table-responsive-md">
    <thead>
    <tr>
      <th></th>
      <th>{{$t('views.excmdevice.show.brand')}}</th>
      <th>{{$t('views.excmdevice.show.model')}}</th>
      <th>{{$t('views.excmdevice.show.serialNumber')}}</th>
      <th>{{$t('views.excmdevice.show.localization')}}</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="item in items" class="p-2" :key="item['@id']">
      <td>
        <div style="height: 60px; width: 60px; cursor: pointer;" @click="downloadPDF(getIdLink(item['@id']), item.serialNumber)" v-b-tooltip.hover :title="$t('views.excmdevice.show.downloadPDF')">
          <qr-code :text="item['@id']"></qr-code>
        </div>
      </td>
      <td>
        {{item.idDeviceModel.idDeviceBrand.brandTitle}}
      </td>
      <td>
        {{item.idDeviceModel.model}}
      </td>
      <td>{{item.serialNumber}}</td>
      <td>
        <span v-if="item.city">{{item.city}}, </span>
        <span v-if="item.street">{{item.street}} </span>
        <span v-if="item.building">{{item.building}}</span>
      </td>
      <td>
        <div class="btn-group float-right">
          <router-link v-if="item && ableToShowDevice" tag="button" class="btn btn-link fa fa-search fa-lg" :to="{name: 'EXCMDeviceShow', params: { id: item['@id'] }}">
          </router-link>
          <router-link v-if="item && ableToUpdateDevice" tag="button" class="btn btn-link fa fa-edit fa-lg" :to="{name: 'EXCMDeviceShow', params: { id: item['@id'] }}">
          </router-link>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { checkPermission } from '@/utils/checkRoles'
import Swal from 'sweetalert2'
import getId from '@/utils/getIdFromLink'

export default {
  name: 'CaseDevice',
  computed: {
    ...mapGetters({
      case: 'excmcase/show/retrieved'
    }),
    items () {
      let array = []
      array.push(this.case.idDevice)
      return array
    },
    ableToShowDevice () {
      return checkPermission('devices', 'EXCMDeviceShow')
    },
    ableToUpdateDevice () {
      return checkPermission('devices', 'EXCMDeviceUpdate')
    }
  },
  methods: {
    getIdLink (iri) {
      return getId(iri)
    },
    downloadPDF (id, deviceSerialNumber) {
      this.$http
        .get('api/e_x_c_m_devices/' + id + '/getqrcode', {
          responseType: 'arraybuffer'
        })
        .then(response => {
          var myBlob = new Blob([response.data], { type: 'application/pdf' })
          var url = window.URL.createObjectURL(myBlob)
          var a = document.createElement('a')
          document.body.appendChild(a)
          a.href = url
          let fileName = 'device_' + deviceSerialNumber + '.pdf'
          a.download = fileName // Name file to download
          a.click()
          setTimeout(function () { window.URL.revokeObjectURL(url) }, 0)
        })
        .catch(error => {
          Swal({
            type: 'error',
            title: this.$t('notifications.store.errorTitle') + ' - ' + error,
            showConfirmButton: false,
            timer: 2500
          })
        })
    }
  }
}
</script>

<style scoped>

</style>
